import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { spacing } from "#app/theme/v2/spacing";
import { Button } from "#components/atoms/Button/Button";
import { Text } from "#components/atoms/Typographies/Text";
import { Flex } from "#shared/view/components/Flex";

type MaterialSpecificationEmptyStateProps = {
  onAddMaterial: () => void;
};

export const MaterialSpecificationEmptyState = ({
  onAddMaterial,
}: MaterialSpecificationEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <Flex
      direction="column"
      align="center"
      gap={spacing[6]}
      style={{ padding: `${spacing[24]} ${spacing[12]}` }}
    >
      <Flex direction="column" align="center" gap={spacing[2]}>
        <Text size="base" type="medium">
          {t("onboardingV2.materialSpecification.emptyState.title")}
        </Text>
        <Text size="small" type="regular" color={colors.text.secondaryDefault}>
          {t("onboardingV2.materialSpecification.emptyState.subtitle")}
        </Text>
      </Flex>
      <Button variant="secondary" onClick={onAddMaterial}>
        {t("onboardingV2.materialSpecification.emptyState.button")}
      </Button>
    </Flex>
  );
};
